var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recommended-vacancies"},[_c('div',{staticClass:"recommended-vacancies__title"},[_vm._v(_vm._s(_vm.$tMyVacancy('Recommended vacancies')))]),_c('RecommendedVacanciesList',{staticClass:"recommended-vacancies__list"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }